import { Anchor, Button, Grid, Image, List, Stack, Text, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import {
  imgDinLabelLaptop,
  imgEtiquetaConMarcaDeAgua,
  imgEtiquetaSinMarcaDeAgua,
} from "../shared/images";
import { NavBarContainer } from "./NavBarContainer";

const DOWNLOAD_URL =
  "https://labelmaster.azurewebsites.net/labelmaster/setup.exe";

export function InstallPage() {
  const { t } = useTranslation();

  return (
    <NavBarContainer variant="marketing" title={t("install.title")}>
      <Stack gap="xl">
        <Grid align="center">
          <Grid.Col span={{ base: 12, md: 7 }}>
            <Title order={3} mb="sm">
              {t("install.requirements")}
            </Title>
            <List>
              <List.Item>{t("install.reqWindows")}</List.Item>
              <List.Item>{t("install.reqInternet")}</List.Item>
              <List.Item>{t("install.reqRam")}</List.Item>
              <List.Item>{t("install.reqDisk")}</List.Item>
            </List>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 5 }}>
            <Image src={imgDinLabelLaptop} alt="" maw={280} mx="auto" />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack align="center">
              <Image src={imgEtiquetaConMarcaDeAgua} alt="" maw={200} />
              <Text fw={600}>{t("install.freeTag")}</Text>
              <Text ta="center" size="sm">
                {t("install.freeText")}
              </Text>
              <Button component="a" href={DOWNLOAD_URL}>
                {t("nav.download")}
              </Button>
            </Stack>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack align="center">
              <Image src={imgEtiquetaSinMarcaDeAgua} alt="" maw={200} />
              <Text fw={600}>{t("install.paidTitle")}</Text>
              <Button component={Link} to="/buy">
                {t("install.buyApp")}
              </Button>
            </Stack>
          </Grid.Col>
        </Grid>

        <Text ta="center" size="sm">
          <Anchor component={Link} to="/viewdistributors">
            {t("install.distributorsLink")}
          </Anchor>
        </Text>
      </Stack>
    </NavBarContainer>
  );
}
